export default "__VITE_ASSET__CVA7B8nl__"